import { ProductListItem } from '../../model';
import { DynamicCard } from '../DynamicCard/DynamicCard';
import { imageSizes, StyledProductList } from './styled';

export type ProductListProps = { items: ProductListItem[]; listName?: string; listId?: string };

// The X top most items will have their media rendered as priority for improvement of LCP
export const PRIORITY_COUNT = 4;

export const ProductList = ({ items, listName, listId }: ProductListProps) => {
	if (!items.length) {
		return null;
	}

	return (
		<StyledProductList>
			{items.map((item, index) => (
				<DynamicCard
					index={index}
					imageSizes={imageSizes}
					key={item.id}
					item={item}
					listName={listName}
					listId={listId}
					priority={index < PRIORITY_COUNT}
				/>
			))}
		</StyledProductList>
	);
};
